module.exports = __webpack_public_path__ + "img/honer1.b00963bd.jpg";